<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5">
          Notifications
        </span>
      </template>
    </TopHeader>
    <PlaceholderWrapper
      :is-loading="!isInit"
      :is-empty="$store.state.notifications.length <= 0"
      empty-message="You don't have any notifications at the moment"
      empty-icon="mdi-inbox"
      :empty-height="250"
      :empty-icon-size="60"
    >
      <template v-slot:content>
        <v-row class="mt-10">
          <v-col
            cols="12"
            class="py-0"
            v-for="(n, i) in $store.state.notifications"
            :key="i"
          >
            <Notification :notification="n" />
          </v-col>
        </v-row>
      </template>
    </PlaceholderWrapper>
  </v-container>
</template>

<script>
import PlaceholderWrapper from "@/components/base/PlaceholderWrapper"
import Notification from "@/components/base/Notification"
import TopHeader from "@/components/base/TopHeader"
export default {
  components: {
    PlaceholderWrapper,
    Notification,
    TopHeader
  },
  data() {
    return {
      isInit: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.isInit = true
    }, 100)
  }
}
</script>

<style lang="scss" scoped></style>
